import { attach as attachABTesting } from './fwnABTesting/attach'
import { attach as attachAnalytics } from './fwnAnalytics/attach'
import { attach as attachBackendABTesting } from './fwnBackendABTesting/attach'
import { attach as attachChat } from './fwnChat/attach'
import { attach as attachConsole } from './fwnConsole/attach'
import { attach as attachFwnCookies } from './fwnCookies/attach'
import { attach as attachHydrate } from './fwnHydrate/attach'
import { attach as attachMemoryStorage } from './fwnMemoryStorage/attach'
import { attach as attachPIP } from './fwnPIP/attach'
import { attach as attachPlay } from './fwnPlay/attach'
import { attach as attachPlayer } from './fwnPlayer/attach'
import { attach as attachScreenReader } from './fwnScreenReaderAlert/attach'
import { attach as attachShopping } from './fwnShopping/attach'
import { attach as attachWidgets } from './fwnWidgets/attach'
import { setup as setupUrlDiscovery } from './urlDiscovery/setup'
import { init } from './init'
import { loadInvitationLazy } from './loadInvitationLazy'
import { loadShareLinkOrSoftPIPLazy } from './loadShareLinkOrSoftPIPLazy'
import { restoreScrollLazy } from './restoreScrollLazy'

let hasInitialized = false

/**
 *
 */
export function initAllFwnModules() {
  if (hasInitialized) {
    return
  }
  hasInitialized = true
  init(() => {
    // Order of attach might matter
    attachFwnCookies()
    attachAnalytics({ shouldSendPageLoadPixelEvent: true })
    attachConsole()
    attachHydrate()
    attachShopping()
    attachMemoryStorage()
    attachPIP()
    attachPlay()
    attachPlayer()
    attachWidgets()
    attachChat()
    attachScreenReader()
    attachABTesting()
    attachBackendABTesting()

    setupUrlDiscovery()
    restoreScrollLazy()
    loadInvitationLazy()
    loadShareLinkOrSoftPIPLazy()
  })
}

export const TEST_ONLY = {
  reset() {
    hasInitialized = false
  },
}
